import { createActions } from 'redux-actions';

export const actions = createActions('FETCH_TRANSLATIONS', 'TRANSLATIONS_RESPONSE');
